import {
  createPolicy,
  getLatestPolicy,
  getPolicyById,
  updatePolicyById,
  deletePolicyById,
  createOrUpdateTerms,
  getLatestTerms,
  getTermsById,
  updateTermsById,
  deleteTermsById,
} from "../../helpers";

import { setLoading, setPolicy, setTerms, setError } from "./reducer";
import { showToast } from "../toast/reducer";

// Policy Thunks
export const fetchLatestPolicy = (params) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const res = await getLatestPolicy(params);
    dispatch(setPolicy(res?.data || res?.data || null));
  } catch (err) {
    dispatch(setError(err.data));
  } finally {
    dispatch(setLoading(false));
  }
};

export const fetchPolicyById = (id) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const res = await getPolicyById(id);
    dispatch(setPolicy(res?.data || res?.data || null));
  } catch (err) {
    dispatch(setError(err.data));
  } finally {
    dispatch(setLoading(false));
  }
};

export const createPolicyItem = (data) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const res = await createPolicy(data);
    dispatch(setPolicy(res?.data || res?.data || null));
    dispatch(showToast({ type: "success", data: res?.data || "Privacy Policy created successfully" }));
  } catch (err) {
    dispatch(setError(err.data));
    dispatch(showToast({ type: "error", data: err.data || "Failed to create policy" }));
  } finally {
    dispatch(setLoading(false));
  }
};

export const updatePolicyItem = (id, data) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const res = await updatePolicyById(id, data);
    dispatch(setPolicy(res?.data || res?.data || null));
    dispatch(showToast({ type: "success", data: res?.data || "Privacy Policy updated successfully" }));
  } catch (err) {
    dispatch(setError(err.data));
    dispatch(showToast({ type: "error", data: err.data || "Failed to update policy" }));
  } finally {
    dispatch(setLoading(false));
  }
};

export const deletePolicyItem = (id) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const res = await deletePolicyById(id);
    dispatch(showToast({ type: "success", data: res?.data || "Privacy Policy deleted successfully" }));
    // Optionally clear from state after delete
  } catch (err) {
    dispatch(setError(err.data));
    dispatch(showToast({ type: "error", data: err.data || "Failed to delete policy" }));
  } finally {
    dispatch(setLoading(false));
  }
};

// Terms Thunks
export const fetchLatestTerms = (params) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const res = await getLatestTerms(params);
    dispatch(setTerms(res?.data || res?.data || null));
  } catch (err) {
    dispatch(setError(err.data));
  } finally {
    dispatch(setLoading(false));
  }
};

export const fetchTermsById = (id) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const res = await getTermsById(id);
    dispatch(setTerms(res?.data || res?.data || null));
  } catch (err) {
    dispatch(setError(err.data));
  } finally {
    dispatch(setLoading(false));
  }
};

export const createOrUpdateTermsItem = (data) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const res = await createOrUpdateTerms(data);
    dispatch(setTerms(res?.data || res?.data || null));
    dispatch(showToast({ type: "success", data: res?.data || "Terms & Conditions saved successfully" }));
  } catch (err) {
    dispatch(setError(err.data));
    dispatch(showToast({ type: "error", data: err.data || "Failed to save terms" }));
  } finally {
    dispatch(setLoading(false));
  }
};

export const updateTermsItem = (id, data) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const res = await updateTermsById(id, data);
    dispatch(setTerms(res?.data || res?.data || null));
    dispatch(showToast({ type: "success", data: res?.data || "Terms & Conditions updated successfully" }));
  } catch (err) {
    dispatch(setError(err.data));
    dispatch(showToast({ type: "error", data: err.data || "Failed to update terms" }));
  } finally {
    dispatch(setLoading(false));
  }
};

export const deleteTermsItem = (id) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const res = await deleteTermsById(id);
    dispatch(showToast({ type: "success", data: res?.data || "Terms & Conditions deleted successfully" }));
    // Optionally clear from state after delete
  } catch (err) {
    dispatch(setError(err.data));
    dispatch(showToast({ type: "error", data: err.data || "Failed to delete terms" }));
  } finally {
    dispatch(setLoading(false));
  }
};


